import React from 'react';
import {TabView} from '../../../components/tab/TabView';
import {
  CreativeAdActiveTable,
  CreativeAdCompletedTable,
} from './CreativeAdTable';
import {useFilter} from '../../../controllers/useFilter';
import {SearchFilter} from '../../../components/filter/Filters';

export const CreativeAdTabView = props => {
  const {route: {params} = {}} = props;
  const {onChangeFilter, searchValue} = useFilter({});
  const tabs = {
    active: {
      label: 'Active',
      view: <CreativeAdActiveTable searchValue={searchValue} />,
    },
    completed: {
      label: 'Completed',
      view: <CreativeAdCompletedTable searchValue={searchValue} />,
    },
  };

  return (
    <TabView
      tabs={tabs}
      params={params}
      {...props}
      actions={[
        <SearchFilter
          value={searchValue}
          onChangeFilter={onChangeFilter}
          placeholder="Search"
        />,
      ]}
    />
  );
};
